import AppContext, { contextValue } from '~/context'
import { Chatbot, Footer, Hero, Navbar } from '~/components/home'
import React, { FC } from 'react'

import cookie from 'cookie-cutter';
import { LayoutProps } from '../../types/LayoutProps'
import { SEOHead } from '~/components/common/seo'
import { SocialShare } from '~/components/common'
import { useSession } from 'next-auth/react'
import { useRouter } from 'next/router'
import { makeSelectIsPremium } from '~/store/auth/selector'
import { createStructuredSelector } from 'reselect'
import { connect } from 'react-redux'
import { withI18n } from '~/hocs'

import AssociateToolbar from '~/components/creator/AssociateToolbar'
const MainLayout: FC<LayoutProps> = ({
  children,
  banners,
  path,
  headerData,
  categories,
  isPremium
}) => {
  const router = useRouter();
  const { data: session } = useSession();
  const [checkAssociate, setCheckAssociate] = React.useState(false);

  React.useEffect(() => {
      const associateEmail =  cookie.get('associate_email') || session?.user?.creatorAssociateAcc;
      if (session?.token && associateEmail.length > 1) {
        setCheckAssociate(true);
      }
    }, []);
  return (
    <AppContext.Provider value={contextValue}>
      { checkAssociate == true && <AssociateToolbar />}
      <Navbar headerData={headerData} />
      <Chatbot/>
      {/* <Hero banners={banners} /> */}

      {children}
      <SEOHead path={path} />
      <SocialShare />
      {router.pathname !== '/creatorP/signin' && <Footer/>}
    </AppContext.Provider>
  )
}
const mapStateToProps = createStructuredSelector({
  isPremium: makeSelectIsPremium(),
})
export default connect(mapStateToProps)(withI18n(MainLayout))
